import { ReactNode } from 'react';

import { mergeClasses } from '@/utils';

import { DonutProgressChart } from '@/components/common';

export interface IProgressCircle extends React.HTMLAttributes<HTMLDivElement> {
  value?: string | ReactNode;
  label?: string;
  percentage?: number;
  backgroundClassName?: string;
  foregroundClassName?: string;
  disabled?: boolean;
}

const ProgressCircle = ({
  className,
  backgroundClassName = 'stroke-neutral-3 dark:stroke-neutral-9',
  foregroundClassName = 'stroke-primary-base',
  disabled = false,
  value,
  label,
  percentage = 0,
  ...props
}: IProgressCircle) => {
  return (
    <div className={mergeClasses('relative size-[160px]', className)} {...props}>
      <div data-slot="ring" className="relative">
        <DonutProgressChart
          className="size-[160px] -rotate-90"
          backgroundClassName={disabled ? 'stroke-neutral-4' : backgroundClassName}
          foregroundClassName={disabled ? 'stroke-neutral-6' : foregroundClassName}
          strokeWidth={8}
          percentage={percentage}
        ></DonutProgressChart>
      </div>
      <div
        data-slot="donut-content"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center"
      >
        <div
          data-slot="donut-label"
          className="text-h6 font-bold text-neutral-7 dark:!text-neutral-6"
        >
          {label}
        </div>
        <div
          data-slot="donut-value"
          className={mergeClasses(
            'text-h2 font-bold text-neutral-9 dark:text-neutral-0',
            !value && 'tracking-[1px]',
          )}
        >
          {value || '--'}
        </div>
      </div>
    </div>
  );
};

export { ProgressCircle };
